import React from "react";

import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// import LiveMatchesSlider from "./LiveMatchesSlider";

export default function LiveUpcomingMatchesSlider() {
  const navigate = useNavigate();

  const { i18n } = useTranslation();

  // ===== REDUX =====
  const { lobbyBannerList } = useSelector((state) => state.casinoLobby || {});

  // ===== CASINO DATA =====
  const firstDepositData = lobbyBannerList?.["9"]?.firstCardBanner;

  const banner = firstDepositData;

  const lang = i18n.language || "en";

  const localizedInfo =
    banner?.bannerInfo?.[lang] || banner?.bannerInfo?.en || "";

  const imageUrl = isMobile ? banner?.mobileImageUrl : banner?.imageUrl;

  const buttonLabel = banner?.buttonTitle?.[lang] || banner?.buttonTitle?.en;

  const buttonIcon = banner?.buttonIcon || null;

  const allBanners = lobbyBannerList?.["9"]?.allBanners || [];

  const cardType = banner?.cardType || "";

  // ===== HANDLERS =====
  const handleRightBannerClickSmall = (banner) => {
    const url = banner?.redirect_url;

    if (!url) return;

    if (url.startsWith("http://") || url.startsWith("https://")) {
      window.location.href = url;
    } else {
      navigate(url);
    }
  };

  const handleLeftBannerClickSmall = (banner) => {
    const url = banner?.redirectUrl;

    if (!url) return;

    if (url.startsWith("http")) {
      window.location.href = url;
    } else {
      navigate(url);
    }
  };

  return (
    <div className="w-full px-1 py-0">
      {/* {process.env.REACT_APP_SHOW_LIVE_MATCHES_SLIDER === "true" && (
        <LiveMatchesSlider />
      )} */}

      {/* ================= CASINO SECTION ================= */}
      <div className="flex flex-col min-[1030px]:flex-row gap-4 pt-4 md:pt-4 pb-4">
        {/* LEFT BANNER */}
        {banner && (cardType !== "gameCard" || !isMobile) && (
          <div className="w-full min-[1030px]:w-1/2">
            <button
              onClick={() => handleLeftBannerClickSmall(banner)}
              className="relative w-full bg-[#352099] rounded-[10px] p-4 flex items-center justify-center gap-6 h-full"
            >
              {!isMobile && (
                <img
                  src={imageUrl || "/images/Depositmodalimg1.png"}
                  alt="bonus"
                  className="max-w-[200px] max-h-[200px] object-contain rounded-[10px]"
                />
              )}

              <div className="flex flex-col flex-1">
                <div
                  className="text-white text-[14px] font-medium leading-tight"
                  dangerouslySetInnerHTML={{ __html: localizedInfo }}
                />

                {buttonLabel && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/user/deposit");
                    }}
                    className="mt-4 bg-[#FFD200] text-[#170D1C] font-bold text-[14px] rounded-lg px-3 py-2 flex items-center gap-2 w-fit"
                  >
                    {buttonIcon && (
                      <img
                        src={buttonIcon}
                        alt="icon"
                        className="w-[16px] h-[16px]"
                      />
                    )}

                    {buttonLabel}
                  </button>
                )}
              </div>
            </button>
          </div>
        )}

        {/* RIGHT BANNERS */}
        <div className="w-full min-[1030px]:w-1/2 grid grid-cols-2 sm:grid-cols-2 gap-3 mt-2 lg:mt-0">
          {allBanners.length > 0 &&
            allBanners.map((group) =>
              group?.banners?.map((b) => {
                const bImage = isMobile ? b.mobileImageUrl : b.imageUrl;

                const lang = i18n.language || "en";

                const bTitle =
                  b?.name?.[lang] ||
                  b?.name?.[lang?.split("-")[0]] ||
                  b?.name?.en ||
                  "";

                const isClickable = Boolean(b.redirectUrl);

                return (
                  <div
                    key={b.id}
                    role={isClickable ? "button" : undefined}
                    tabIndex={isClickable ? 0 : -1}
                    onClick={() =>
                      isClickable &&
                      handleRightBannerClickSmall({
                        redirect_url: b.redirectUrl
                      })
                    }
                    onKeyDown={(e) => {
                      if (isClickable && (e.key === "Enter" || e.key === " ")) {
                        handleRightBannerClickSmall({
                          redirect_url: b.redirectUrl
                        });
                      }
                    }}
                    className={`flex flex-col bg-[#230E2F] rounded-[10px] overflow-hidden h-full transition-transform
                    ${
                      isClickable
                        ? "cursor-pointer hover:scale-[1.01]"
                        : "cursor-default opacity-80"
                    }
                  `}
                  >
                    {/* Image */}
                    <div className="relative w-full h-full p-2 pb-0 md:p-4 md:pb-0">
                      <img
                        src={bImage}
                        alt={bTitle || "Banner"}
                        className="w-full h-full object-cover rounded-[10px]"
                      />

                      {b?.shortDesc?.[lang] && (
                        <span
                          className="
                            absolute bottom-0 right-2
                            text-white text-[10px] font-bold
                            px-2 py-1 rounded
                            sm:hidden
                          "
                          style={{
                            background:
                              "linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, #170D1C 99.31%)"
                          }}
                        >
                          {b?.shortDesc?.[lang]}
                        </span>
                      )}
                    </div>

                    {/* Info */}
                    <div className="flex justify-between items-center py-2 px-4">
                      <h3 className="text-sm font-bold text-white truncate">
                        {bTitle}
                      </h3>

                      {b?.shortDesc?.[lang] && (
                        <span className="text-white font-bold text-[10px] truncate hidden sm:inline">
                          {b.shortDesc[lang]}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })
            )}
        </div>
      </div>
    </div>
  );
}
